/* ================================================================
   CHEZSAMOS — custom.js
   Scroll-reveal IntersectionObserver pour [data-sb-reveal]
   + helpers UI : FAQ accordion, sticky CTA
   ================================================================ */

(function () {
  'use strict';

  /* ── 1. SCROLL REVEAL ──────────────────────────────────────────── */
  function initReveal() {
    var els = Array.from(document.querySelectorAll('[data-sb-reveal]'));
    if (!els.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -40px 0px'
    });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ── 2. FAQ ACCORDION ──────────────────────────────────────────── */
  function initFAQ() {
    document.querySelectorAll('.sb-faq__question').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        var answerId = btn.getAttribute('aria-controls');
        var answer   = document.getElementById(answerId);

        // Ferme tous les autres
        document.querySelectorAll('.sb-faq__question').forEach(function (b) {
          if (b !== btn) {
            b.setAttribute('aria-expanded', 'false');
            var id = b.getAttribute('aria-controls');
            var a  = document.getElementById(id);
            if (a) a.style.maxHeight = '0';
          }
        });

        // Toggle courant
        var next = !expanded;
        btn.setAttribute('aria-expanded', String(next));
        if (answer) {
          answer.style.maxHeight = next ? answer.scrollHeight + 'px' : '0';
        }
      });
    });
  }

  /* ── 3. STICKY CTA — show/hide on scroll ──────────────────────── */
  function initStickyCTA() {
    var cta = document.querySelector('.samos-sticky-cta');
    if (!cta) return;
    var threshold = parseInt(cta.dataset.showAfter || '300', 10);

    var ticking = false;
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function () {
          if (window.scrollY > threshold) {
            cta.classList.add('is-visible');
          } else {
            cta.classList.remove('is-visible');
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // état initial
  }

  /* ── 4. BUY NOW — add to cart puis redirect /checkout ─────────── */
  function initBuyNow() {
    document.querySelectorAll('[data-buy-now]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = parseInt(btn.dataset.buyNow, 10);
        if (!variantId) return;

        btn.setAttribute('data-loading', '');
        btn.disabled = true;

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          })
          .then(function (r) { return r.json(); })
          .then(function () {
            window.location.href = '/cart';
          })
          .catch(function () {
            btn.removeAttribute('data-loading');
            btn.disabled = false;
          });
      });
    });
  }

  /* ── 4b. ATC BUTTON — feedback loading ────────────────────────── */
  function initATCFeedback() {
    document.querySelectorAll('[data-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var variantId = parseInt(btn.dataset.variantId || btn.dataset.atc, 10);
        if (!variantId) return;

        btn.setAttribute('data-loading', '');
        var lbl = btn.querySelector('[data-atc-label]') || btn;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          lbl.textContent = '✓ Ajouté !';
          setTimeout(function () {
            btn.removeAttribute('data-loading');
            window.location.href = '/cart';
          }, 600);
        })
        .catch(function () {
          btn.removeAttribute('data-loading');
        });
      });
    });
  }

  /* ── 5. HERO MOBILE SCROLL — image fixe, carte monte par-dessus ── */
  function initHeroMobileScroll() {
    if (window.innerWidth > 767) return;

    var mobileImg = document.querySelector('.nh-mobile-img');
    var gallery   = document.querySelector('.nh-gallery');
    if (!mobileImg || !gallery) return;

    var galleryTop = 0;
    var galleryH   = 0;

    function measure() {
      var rect  = gallery.getBoundingClientRect();
      galleryTop = rect.top + window.scrollY;
      galleryH   = rect.height;
    }

    function onScroll() {
      var past = window.scrollY - galleryTop;
      if (past <= 0) {
        /* avant la galerie — position naturelle */
        mobileImg.style.transform = '';
      } else if (past < galleryH) {
        /* dans la galerie — image reste visuellement fixe */
        mobileImg.style.transform = 'translateY(' + past + 'px)';
      } else {
        /* après la galerie — reset pour ne pas déborder */
        mobileImg.style.transform = '';
      }
    }

    measure();
    onScroll();

    /* Scroll cue : show/hide selon position + clic pour scroller au CTA */
    var cue = document.getElementById('NhScrollCue');
    if (cue) {
      /* Clic sur le pill → scroll smooth jusqu'au bouton CTA */
      var pill = cue.querySelector('.nh-scroll-cue__pill');
      if (pill) {
        pill.addEventListener('click', function () {
          var btn = document.querySelector('.nh-btn-atc');
          if (btn) btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }

      /* Affiche/cache selon position : visible en haut, caché dès qu'on scroll */
      function updateCue() {
        var threshold = galleryH * 0.15; /* ~78px = début de l'effet scroll */
        var past = window.scrollY - galleryTop;
        if (past < threshold) {
          cue.classList.remove('is-hidden');
        } else {
          cue.classList.add('is-hidden');
        }
      }
      updateCue();
      window.addEventListener('scroll', updateCue, { passive: true });
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () { onScroll(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 767) {
        mobileImg.style.transform = '';
      } else {
        measure();
        onScroll();
      }
    });
  }

  /* ── 7. COUNTER ANIMATION ──────────────────────────────────────── */
  function initCounters() {
    /* Trigger stats pop CSS animation when strip enters viewport */
    var strip = document.querySelector('.sb-stats-strip');
    if (strip) {
      new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          strip.classList.add('is-counted');
        }
      }, { threshold: 0.35 }).observe(strip);
    }

    /* Counter number animation */
    var counters = Array.from(document.querySelectorAll('[data-counter]'));
    if (!counters.length) return;

    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) { runCounter(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.6 });

    counters.forEach(function(el) { io.observe(el); });
  }

  function runCounter(el) {
    var target  = parseFloat(el.dataset.counter);
    var suffix  = el.dataset.suffix  || '';
    var prefix  = el.dataset.prefix  || '';
    var dec     = (String(target).indexOf('.') >= 0) ? 1 : 0;
    var dur     = 1800;
    var startTs = null;

    function tick(ts) {
      if (!startTs) startTs = ts;
      var progress = Math.min((ts - startTs) / dur, 1);
      var eased    = 1 - Math.pow(1 - progress, 4); /* easeOutQuart */
      var value    = (eased * target).toFixed(dec);
      /* French thousands separator (non-breaking space) */
      if (dec === 0 && parseFloat(value) >= 1000) {
        value = value.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      }
      el.textContent = prefix + value + suffix;
      if (progress < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* ── Init ──────────────────────────────────────────────────────── */
  function init() {
    initReveal();
    initFAQ();
    initStickyCTA();
    initBuyNow();
    initATCFeedback();
    initHeroMobileScroll();
    initChatPosition();
    initCounters();
  }

  /* ── 6. CHAT TOUJOURS AU-DESSUS DE LA STICKY CTA ───────────────── */
  function initChatPosition() {
    if (window.innerWidth > 767) return;

    var BOTTOM   = 78;  /* 72px bannière + 6px marge */
    var SIZE     = 48;  /* px — icône réduite */
    var pinTimer = null;
    var chatObserver = null;
    var chatEl   = null;
    var ctaVisible = false; /* état CTA indépendant du chatEl */

    var SELECTORS = [
      '#ShopifyChat',
      'inbox-online-store-chat',
      '#shopify-chat',
      'chat-button',
      '[id*="ShopifyChat"]',
      '[id*="shopify-chat"]'
    ];

    function findChat() {
      for (var i = 0; i < SELECTORS.length; i++) {
        var el = document.querySelector(SELECTORS[i]);
        if (el) return el;
      }
      return null;
    }

    /* Applique position + opacité selon ctaVisible */
    function applyState() {
      if (!chatEl) return;
      chatEl.style.setProperty('bottom',  BOTTOM + 'px', 'important');
      chatEl.style.setProperty('height',  SIZE   + 'px', 'important');
      chatEl.style.setProperty('width',   SIZE   + 'px', 'important');
      chatEl.style.setProperty('right',   'auto',         'important');
      chatEl.style.setProperty('left',    '0px',          'important');
      chatEl.style.setProperty('transition', 'opacity 0.25s ease', 'important');
      if (ctaVisible) {
        chatEl.style.setProperty('opacity',        '0',    'important');
        chatEl.style.setProperty('pointer-events', 'none', 'important');
      } else {
        chatEl.style.setProperty('opacity',        '1',    'important');
        chatEl.style.setProperty('pointer-events', 'auto', 'important');
      }
    }

    /* Shopify réinitialise le style → on re-applique immédiatement */
    function onStyleReset() {
      var ok = chatEl.style.getPropertyValue('bottom') === BOTTOM + 'px'
            && chatEl.style.getPropertyValue('height') === SIZE   + 'px';
      if (ok) return;
      clearTimeout(pinTimer);
      pinTimer = setTimeout(applyState, 0);
    }

    function watchChat(el) {
      chatEl = el;
      applyState();
      if (chatObserver) chatObserver.disconnect();
      chatObserver = new MutationObserver(onStyleReset);
      chatObserver.observe(chatEl, { attributes: true, attributeFilter: ['style'] });
    }

    /* Surveille l'injection async du widget Shopify */
    new MutationObserver(function () {
      var found = findChat();
      if (found && found !== chatEl) watchChat(found);
    }).observe(document.body, { childList: true, subtree: true });

    /* Applique immédiatement si déjà dans le DOM */
    var initial = findChat();
    if (initial) watchChat(initial);

    /* Masque le chat quand le bouton CTA hero est visible dans le viewport */
    var ctaBtn = document.querySelector('.nh-btn-atc');
    if (ctaBtn) {
      new IntersectionObserver(function (entries) {
        /* Stocke l'état AVANT de tester chatEl */
        ctaVisible = entries[0].isIntersecting;
        /* Tente de récupérer chatEl s'il n'est pas encore connu */
        if (!chatEl) chatEl = findChat();
        applyState();
      }, { threshold: 0.15 }).observe(ctaBtn);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
